var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Dropdown, fontTokens, RangeSlider, TextInput } from '@leapfinance/geebee-component-library';
import { Divider, Popper } from '@mui/material';
import React from 'react';
function TuitionCFFilterWrapper(props) {
    var _a, _b;
    var getCountryCode = function (value) {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = (value !== null && value !== void 0 ? value : '')) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.split('(')[1]) === null || _c === void 0 ? void 0 : _c.split(')')) === null || _d === void 0 ? void 0 : _d[0];
    };
    return (React.createElement("div", { className: "lfc-flex  lfc-flex-col" },
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2 lfc-py-2" },
            React.createElement("div", { className: "lfc-flex lfc-justify-end lfc-px-4" },
                React.createElement(Dropdown, { className: "lfc-w-[120px] lfc-bg-gbTokens-primary-100  [&>div>div>.MuiOutlinedInput-root]:hover:lfc-bg-gbTokens-primary-100", value: props === null || props === void 0 ? void 0 : props.studentCurrency, disableClearable: true, options: props === null || props === void 0 ? void 0 : props.currencyList, PopperComponent: function (_a) {
                        var children = _a.children, rest = __rest(_a, ["children"]);
                        return (React.createElement(Popper, __assign({}, rest, { sx: __assign(__assign({}, rest.sx), { width: '250px !important' }) }), children));
                    }, renderInput: function (params) {
                        var _a, _b, _c;
                        return (React.createElement(TextInput, __assign({}, params, { inputProps: __assign(__assign({}, params.inputProps), { value: getCountryCode((_c = (_b = (_a = params.inputProps) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '') }), InputProps: __assign(__assign({}, params.InputProps), { sx: function (theme) {
                                    var _a, _b, _c, _d;
                                    return ({
                                        '&.MuiOutlinedInput-root': {
                                            borderRadius: '4px',
                                            backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['100'],
                                            fieldSet: {
                                                borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['300']
                                            },
                                            ':hover': {
                                                backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['100'],
                                                fieldSet: {
                                                    borderColor: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['300']
                                                }
                                            }
                                        }
                                    });
                                } }) })));
                    }, onChange: function (_event, value) {
                        props === null || props === void 0 ? void 0 : props.setCurrency(value);
                    }, textInputProps: {
                        InputProps: {
                            sx: function (theme) {
                                var _a, _b, _c, _d;
                                return ({
                                    '& .MuiOutlinedInput-root': {
                                        display: 'none',
                                        backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                        fieldSet: {
                                            borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                        },
                                        ':hover': {
                                            backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200'],
                                            fieldSet: {
                                                borderColor: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    } })),
            React.createElement("div", { className: "lfc-px-4" },
                React.createElement(RangeSlider, { enableLogScale: true, value: props === null || props === void 0 ? void 0 : props.value, min: props === null || props === void 0 ? void 0 : props.minValue, max: props === null || props === void 0 ? void 0 : props.maxValue, displayInput: true, onChange: function (_, newValue, active) {
                        if (Array.isArray(newValue)) {
                            props === null || props === void 0 ? void 0 : props.setValue(newValue);
                        }
                    }, marks: [
                        { value: props === null || props === void 0 ? void 0 : props.minValue, label: (_a = props === null || props === void 0 ? void 0 : props.minValue) === null || _a === void 0 ? void 0 : _a.toLocaleString() },
                        { value: props === null || props === void 0 ? void 0 : props.maxValue, label: (_b = props === null || props === void 0 ? void 0 : props.maxValue) === null || _b === void 0 ? void 0 : _b.toLocaleString() }
                    ], sx: function (theme) { return ({
                        '& .MuiSlider-markLabel ': __assign(__assign({}, fontTokens.caption2Semibold), { color: theme.palette.grey.A700, transform: 'translateX(-100%)', pointerEvents: 'none' })
                    }); } }))),
        React.createElement(Divider, null),
        React.createElement("div", { className: "lfc-p-2 lfc-self-end " },
            React.createElement(Button, { onClick: function (event) {
                    props === null || props === void 0 ? void 0 : props.handleApply();
                } }, "Apply"))));
}
export default TuitionCFFilterWrapper;
//# sourceMappingURL=TuitionCFFilterWrapper.js.map